// 

export const decorateAdd = (id, dataset, element) => ({
  type: 'DECORATE_ADD',
  payload: {
    id,
    dataset,
    element: element.cloneNode(true),
    // používá se zejména při lazy loadingu, kdy se ještě vkládá do domu než je komponenta načtená
    // to zabraňuje skákání a blikání stránky
    innerHTML: element.innerHTML,
  },
});

export const decorateSetValue = (id, value, fromHTMLParsing = false) => ({
  type: 'DECORATE_SET_VALUE',
  payload: { id, value, fromHTMLParsing },
});

export const decorateSetInstance = (id, instance) => ({
  type: 'DECORATE_SET_INSTANCE',
  payload: { id, instance },
});

export const decorateRemove = (id) => ({
  type: 'DECORATE_REMOVE',
  payload: { id },
});



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/webComponents/actions.js